import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { INFAKT_CUSTOMER_FIELD_MAP } from '../common/submitKorekta'

const FIELD_ORDER = [
	'nazwaFirmy',
	'nip',
	'nazwaUlicy',
	'nrBudynku',
	'nrLokalu',
	'kodPocztowy',
	'nazwaMiejscowosci',
	'adresEmail',
	'infaktClientId',
]

export default function KorektaInfaktSection({ invoice }) {
	const { t } = useTranslation()
	const na = t('korekty.list.table.na')

	const fields = useMemo(
		() =>
			FIELD_ORDER.map(formKey => {
				const payloadKey = INFAKT_CUSTOMER_FIELD_MAP[formKey]
				const value = String(invoice?.[payloadKey] ?? '').trim()
				return {
					key: payloadKey,
					label: t(`korekty.details.infakt.fields.${formKey}`),
					value: value || na,
				}
			}),
		[invoice, na, t]
	)

	const hasAny = useMemo(
		() =>
			FIELD_ORDER.some(formKey => {
				const payloadKey = INFAKT_CUSTOMER_FIELD_MAP[formKey]
				return Boolean(String(invoice?.[payloadKey] ?? '').trim())
			}),
		[invoice]
	)

	return (
		<section className="mt-6">
			<div className="rounded-xl border border-gray-200 bg-white shadow-sm">
				<header className="border-b border-gray-200 p-6">
					<h2 className="text-lg font-semibold text-gray-900">
						{t('korekty.details.infakt.title')}
					</h2>
				</header>

				<div className="p-6">
					{hasAny ? (
						<div className="grid gap-4 text-sm [grid-template-columns:repeat(auto-fit,minmax(220px,1fr))]">
							{fields.map(({ key, label, value }) => (
								<div key={key} className="min-w-0">
									<div className="text-gray-600">{label}</div>
									<div className="font-medium text-gray-900 break-words whitespace-pre-wrap">
										{value}
									</div>
								</div>
							))}
						</div>
					) : (
						<p className="text-sm text-gray-500">{t('korekty.details.infakt.empty')}</p>
					)}
				</div>
			</div>
		</section>
	)
}
